import { isSuperAdmin } from 'helpers/usersRolesHelper';
import { makeAutoObservable, action, computed, toJS, extendObservable, set } from 'mobx';
import domainData from 'store/domainStore';
import tableOptions from 'pages/users/config/config';
import { getInitialParams, saveParamsToStorage } from './common/filterUtils';

const STORAGE_KEY = 'users_filter_params';

const defaultData = {
  name: '',
  email: '',
  phone: '',
};

// Default filter parameters
const defaultFilterParams = {
  params: {
    sort: {
      field: 'lastLoginDate',
      order: 'desc',
    },
    filter: {},
    limit: 50,
    skip: 0,
    search: {
      value: '',
      fields: [],
    },
  },
};

class Users {
  getDefaultStoreProps = () => ({
    users: {
      count: 0,
      data: [],
    },
    filterData: defaultFilterParams,
    userState: {},
    userData: JSON.parse(JSON.stringify(defaultData)),
    userDataErrors: {},
  });

  constructor() {
    makeAutoObservable(this);
    extendObservable(this, { ...this.getDefaultStoreProps() });
  }

  @action
  reset() {
    set(this, this.getDefaultStoreProps());
  }

  @action
  setStoreUsers(newData) {
    this.users.data = [];
    newData.data.forEach(this.addStoreUser);
    this.users.count = newData.count;
  }

  @action
  addStoreUser = element => {
    this.users.data.push(element);
  };

  @action
  setFilter(filter) {
    this.filterData = filter;
    // Save to localStorage using common utility, but exclude search
    if (filter?.params) {
      const { search: _search, ...paramsWithoutSearch } = filter.params;
      const filterToSave = {
        ...filter,
        params: paramsWithoutSearch,
      };
      saveParamsToStorage(STORAGE_KEY, filterToSave);
    }
  }

  // Get current filter parameters using common utility with validation
  getCurrentFilterParams = (urlParams = {}) => {
    const isUserSuperAdmin = domainData.userIsSuperAdmin();
    const subscriptionAccess = domainData.getSubscriptionAllAccess();
    const userContext = { isUserSuperAdmin, subscriptionAccess };

    return getInitialParams(STORAGE_KEY, defaultFilterParams, tableOptions.user, userContext, urlParams);
  };

  @computed
  get storeUsers() {
    const result = toJS(this.users);
    return result;
  }

  @computed
  get filter() {
    const filterToJS = toJS(this.filterData);
    return filterToJS;
  }

  @action
  initializeUserData = currentUser => {
    this.userData = JSON.parse(JSON.stringify(defaultData));
    if (currentUser && !isSuperAdmin(currentUser)) {
      this.userData = { ...this.userData, role: 'sp', serviceProviderId: currentUser.serviceProviderId };
    }
  };
}

export default new Users();
